import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-10" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-2 d-flex align-items-end" }
const _hoisted_21 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_22 = ["onSubmit"]
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 4 }
const _hoisted_33 = { class: "row mt-40" }
const _hoisted_34 = { class: "col-md-6 mb-2" }
const _hoisted_35 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_36 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = { class: "col-md-6 mb-2" }
const _hoisted_41 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_42 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image du produit ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                _ctx.product.pic
                  ? _ctx.product.pic
                  : require('@/assets/images/NoImage.png')
              ,
                class: "rounded-circle me-15",
                style: {"width":"90px","height":"90px","object-fit":"cover"}
              }, null, 8, _hoisted_6),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du produit", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Sensung Smart Watch",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description Produit ", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.desc) = $event)),
                  placeholder: "Write your product description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 512), [
                  [_vModelText, _ctx.product.desc]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editProduct())),
              class: "btn btn-primary btn-sm",
              disabled: _ctx.loadingEdit
            }, [
              (_ctx.loadingEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createTextVNode(" Enregistrer ", -1))
            ], 8, _hoisted_13)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { style: {"font-size":"0.957rem"} }, "Choisir une agence * :", -1)),
              _createVNode(_component_v_select, {
                options: _ctx.agencyList,
                modelValue: _ctx.agency,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agency) = $event)),
                label: "name",
                class: "custom-select-height"
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.auth.can('STOCK'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.receivedAgency && _ctx.receivedAgency(...args))),
                  style: {"margin-top":"1.2rem"}
                }, _cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "flaticon-check-mark-1" }, null, -1),
                  _createTextVNode(" Reçu ", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_vue_good_table, {
      columns: _ctx.columns,
      rows: _ctx.product.variantsList
    }, {
      "table-row": _withCtx((props) => [
        (props.column.field === 'inventory_ref')
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(($event: any) => (_ctx.updateInventoryRef(props.row)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((props.row.inventory_ref) = $event)
                  }, null, 8, _hoisted_24), [
                    [_vModelText, props.row.inventory_ref]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary btn-sm"
                  }, [
                    _createElementVNode("i", { class: "flaticon-diskette" })
                  ], -1))
                ])
              ], 40, _hoisted_22)
            ]))
          : (props.column.field === 'stores')
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                (
            props.row.inventories_stores &&
            props.row.inventories_stores.length != 0
          )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.row.inventories_stores, (str, indx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "text-nowrap",
                        key: indx
                      }, [
                        _createTextVNode(_toDisplayString(str.magasin.name) + " ", 1),
                        _createElementVNode("small", null, " (" + _toDisplayString(str.magasin.market) + ")", 1)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : (props.column.field === 'qty_not_received')
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "-500000",
                      max: "500000",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((props.row.qty_not_received) = $event)
                    }, null, 8, _hoisted_28), [
                      [_vModelText, props.row.qty_not_received]
                    ]),
                    (_ctx.auth.can('STOCK'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          style: {"margin-left":"1%"},
                          class: "btn btn-info",
                          onClick: ($event: any) => (_ctx.editQnty(props.row))
                        }, _cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "ph ph-floppy-disk" }, null, -1)
                        ]), 8, _hoisted_29))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (props.column.field === 'action')
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    (props.row.qty_not_received != 0 || props.row.qty == 0)
                      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.auth.can('STOCK'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-success",
                                  onClick: ($event: any) => (_ctx.receiveInventory(props.row))
                                }, _cache[16] || (_cache[16] = [
                                  _createElementVNode("i", { class: "ph ph-check-circle" }, null, -1)
                                ]), 8, _hoisted_31))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.formattedRow[props.column.field]), 1))
      ]),
      _: 1
    }, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Historique")
          ], -1)),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsHist,
              rows: _ctx.histories
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [17]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'history_type')
                  ? (_openBlock(), _createElementBlock("b", _hoisted_37, _toDisplayString(props.row.text), 1))
                  : (props.column.field === 'action_by_name')
                    ? (_openBlock(), _createElementBlock("b", _hoisted_38, _toDisplayString(props.row.action_by_name), 1))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Colis avec ce produit")
          ], -1)),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsColis,
              rows: _ctx.colis
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [20]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'parcel_code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(props.row.parcel_code), 1),
                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ])
    ])
  ], 64))
}